/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
import {Code} from '../../components/utils/code';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ul: "ul",
    li: "li",
    h3: "h3",
    ol: "ol",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Controlling API throughput is a breeze with WebSemaphore. Here is a quick overview of the technical features:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Simple setup"
      }), "\n", _jsx(_components.li, {
        children: "Developer-oriented"
      }), "\n", _jsx(_components.li, {
        children: "Typical \"acquire\" and \"release\" operations"
      }), "\n", _jsx(_components.li, {
        children: "REST and WebSockets protocols supported"
      }), "\n", _jsx(_components.li, {
        children: "Lightweight JavaScript-based, AI-assisted mappings"
      }), "\n", _jsx(_components.li, {
        children: "On-the-fly configurability"
      }), "\n", _jsx(_components.li, {
        children: "Synchronous (spike-arrest style) and asynchronous (queue-style) modes"
      }), "\n", _jsx(_components.li, {
        children: "Stack-independent"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "The documentation provides examples, API documentation and various perspectives, but in essense it comes down to a few steps."
    }), "\n", _jsx(_components.h3, {
      children: "Install the package"
    }), "\n", _jsx(Code, {
      language: "shell",
      value: `npm i --save websmaphore`
    }), "\n", _jsx(_components.h3, {
      children: "Create a semaphore"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Be ", _jsx(_components.a, {
          href: "/auth",
          children: "signed in"
        }), " or ", _jsx(_components.a, {
          href: "/auth/signup",
          children: "sign up"
        }), " first"]
      }), "\n", _jsxs(_components.li, {
        children: ["Create a semaphore in the ", _jsx(_components.a, {
          href: "/semaphore",
          children: "semaphores"
        }), " section"]
      }), "\n", _jsxs(_components.li, {
        children: ["Create a key in the ", _jsx(_components.a, {
          href: "/semaphore/keys",
          children: "keys"
        }), " section"]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Use it"
    }), "\n", _jsx(Code, {
      language: "typescript",
      theme: "vs-dark",
      height: "500px",
      value: `import { WebSemaphoreHttpClientManager } from "websemaphore";
import fetch from "node-fetch";

const websemaphoreManager = WebSemaphoreHttpClientManager();

const websemaphoreClient = websemaphoreManager.initialize({ fetch, token: APIKEY });


const initHandler = (...) => {
    // ...
    const resp = await websemaphoreClient.semaphore.acquire(SEMAPHORE_ID, msg as any);
    // ...
}

const processingHandler = (...) => {
    // ...
    // do work
    // ...
    const resp = await websemaphoreClient.semaphore.release(SEMAPHORE_ID, { channelId: "default" });
    // ...
}
`
    }), "\n", _jsx(_components.h3, {
      children: "What about other languages"
    }), "\n", _jsx(_components.p, {
      children: "The client library and the examples are currently provided only in TypeScript/JavaScript.\nWe provide the OpenAPI and AsyncAPI specs which make it simple to connect to any client that supports those.\nIf you would like to collaborate on the SDK for a particular stack or language, drop us a note."
    }), "\n", _jsx(_components.h3, {
      children: "See also"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/getting-started",
          children: "Getting Started"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/concepts/protocols",
          children: "Protocols"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/v1/examples",
          children: "Examples"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["Usage: ", _jsx(_components.a, {
          href: "/docs/v1/usage/rest",
          children: "REST"
        }), " and ", _jsx(_components.a, {
          href: "/docs/v1/usage/websockets",
          children: "Websockets"
        })]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
